import React, { useEffect, useState } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import DeviceInstallationSerive from "src/service/deviceInstallation";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
import Select from "react-select";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Vehicle and Device Setup Form ",
  },
];

const validationSchema = yup.object({
  vehicle_category_id: yup.string("").required("vehicle Category is required"),
  vehicle_wheel_id: yup.string("").required("vehicle Wheel is required"),
  // vehicle_no: yup.string("").required("vehicle No is required"),
  vehicle_no: yup
    .string("Enter vehicle No")
    .matches(
      /^[A-Z0-9]+$/,
      "vehicle No should be Uppercase and contain Alphabet and Number Only"
    )
    .min(8, "vehicle No should be of minimum 8 characters in length")
    .max(12, "vehicle No should be of maximum 12 characters in length")
    .required("vehicle No is required"),
  make: yup
    .string("Enter Make")
    .min(2, "Make should be at least 2 character long")
    .max(30, "Make should not exceed 30 character")
    .required("Make is Required"),
  model: yup
    .string("Enter Model")
    .min(2, "Model should be at least 2 character long")
    .max(30, "Model should not exceed 30 character")
    .required("Model is Required"),

  // imei_no: yup.string("").required("imei is required"),
  // device_name: yup.string("").required("device name is required"),
});

const DeviceInstallationForm = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [vehicle_category, setVehicle_category] = useState([]);
  const [wheel, setWheel] = useState([]);

  const [installation_datetime_value, setinstallation_datetime_value] =
    useState({
      installation_datetime: getCurrentDateTime(),
    });
  const [device_name, setdevice_name] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedWheel, setSelectedWheel] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const [vehichle, setVehichleCate] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [wheels, setWheels] = useState(null);

  const fetch_vehicle_category = async () => {
    try {
      const res = await DeviceInstallationSerive.getvehicle_category_for_agency(
        {}
      );
      setVehicle_category(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetch_wheel_no = async () => {
    try {
      const res = await DeviceInstallationSerive.getvehicle_wheel_for_agency(
        {}
      );
      setWheel(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTime = (event) => {
    // Handle form field changes
    setinstallation_datetime_value({
      ...values,
      [event.target.name]: event.target.value,
    });
    // alert(setinstallation_datetime_value);
  };

  function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const fetchDeviceData = async (batch_no) => {
    try {
      const res = await DeviceInstallationSerive.get_device_list_for_agency({
        ag_u_id: sessionData.data.id,
        users_user_type: sessionData.data.user_type,
      });
      setdevice_name(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetch_imei_no = (event) => {
    try {
      const selectedDevice = device_name.find(
        (option) => option.device_name === event
      );

      // Assuming your response structure has an 'imei_no' property
      const selected_imei_no = selectedDevice?.imei_no || "";

      // Update the values object with the fetched imei_no
      handleChange({
        target: {
          name: "imei_no",
          value: selected_imei_no,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_imei_no();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    agency_user_id: sessionData.data.id,
    vehicle_category_id: "",
    vehicle_wheel_id: "",
    vehicle_no: "",
    make: "",
    model: "",
    imei_no: "",
    device_name: "",
    installation_datetime: installation_datetime_value.installation_datetime,
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values, { resetForm }) => {
        // alert(JSON.stringify(values, null, 2));
        // console.log(JSON.stringify(values, null, 2));

        if (!values.device_name) {
          delete values.device_name;
          delete values.imei_no;
          delete values.installation_datetime;
        }

        // return;
        try {
          const res = await DeviceInstallationSerive.saveDeviceInstallationData(
            values
          );
          swal("success", res.message, "success");
          setinstallation_datetime_value({
            installation_datetime: getCurrentDateTime(),
          });
          resetForm();
          setTimeout(() => {
            navigate("/vehicleDetailsLists");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  useEffect(() => {
    fetch_vehicle_category();
    fetchDeviceData();
    fetch_wheel_no();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const handleVehichletype = (event) => {
    setVehichleCate(event.target.value);
  };
  const handleWheeltype = (event) => {
    setWheels(event.target.value);
  };

  return (
    <div>
      <Breadcrumb title="Device Installation Form" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={9}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Device Installation Form
            </Typography>
          </Grid>
          <Grid
            item
            xs={3}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/vehicleDetailsLists");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center">
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "1px;",
            }}
          ></Grid>
        </Grid>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid
              item
              lg={4}
              md={6}
              sm={12}
              xs={12}
              style={{ marginTop: "-5px" }}
            >
              <CustomFormLabel htmlFor="vehicle_category_id">
                Vehicle Category <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Select
                id="vehicle_category_id"
                name="vehicle_category_id"
                value={selectedVehicle}
                onChange={(selectedVehicle) => {
                  // Update the selected option in the state
                  setSelectedVehicle(selectedVehicle);

                  // Call both functions
                  const value = selectedVehicle ? selectedVehicle.value : "";
                  handleVehichletype({
                    target: {
                      name: "vehicle_category_id",
                      value: value,
                    },
                  });
                  handleChange({
                    target: {
                      name: "vehicle_category_id",
                      value: value,
                    },
                  });
                }}
                onBlur={handleBlur}
                options={vehicle_category.map((option) => ({
                  label: option.vehicle_name,
                  value: option.id,
                }))}
                placeholder="Select Vehichle"
                isSearchable
                isClearable
                fullWidth
                variant="outlined"
              />
            </Grid>

            <Grid
              item
              lg={4}
              md={6}
              sm={12}
              xs={12}
              style={{ marginTop: "-5px" }}
            >
              <CustomFormLabel htmlFor="vehicle_wheel_id">
                No of Wheels <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Select
                id="vehicle_wheel_id"
                name="vehicle_wheel_id"
                value={selectedWheel}
                onChange={(selectedWheel) => {
                  // Update the selected option in the state
                  setSelectedWheel(selectedWheel);

                  // Call both functions
                  const value = selectedWheel ? selectedWheel.value : "";
                  handleWheeltype({
                    target: {
                      name: "vehicle_wheel_id",
                      value: value,
                    },
                  });
                  handleChange({
                    target: {
                      name: "vehicle_wheel_id",
                      value: value,
                    },
                  });
                }}
                onBlur={handleBlur}
                options={wheel.map((option) => ({
                  label: option.wheel_type,
                  value: option.id,
                }))}
                placeholder="Select Wheel"
                isSearchable
                isClearable
                fullWidth
                variant="outlined"
              />
            </Grid>

            <Grid
              item
              lg={4}
              md={6}
              sm={12}
              xs={12}
              style={{ marginTop: "-5px" }}
            >
              <CustomFormLabel htmlFor="vehicle_no">
                Vehicle No <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="vehicle_no"
                name="vehicle_no"
                type="text"
                value={values.vehicle_no}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.vehicle_no && Boolean(errors.vehicle_no)}
                helperText={touched.vehicle_no && errors.vehicle_no}
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid
              item
              lg={4}
              md={6}
              sm={12}
              xs={12}
              style={{ marginTop: "-5px" }}
            >
              <CustomFormLabel htmlFor="make">
                Make <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="make"
                name="make"
                type="text"
                value={values.make}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.make && Boolean(errors.make)}
                helperText={touched.make && errors.make}
                variant="outlined"
                fullWidth
                placeholder="Enter vehicle Company"
              />
            </Grid>

            <Grid
              item
              lg={4}
              md={6}
              sm={12}
              xs={12}
              style={{ marginTop: "-5px" }}
            >
              <CustomFormLabel htmlFor="model">
                Model <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="model"
                name="model"
                type="text"
                value={values.model}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.model && Boolean(errors.model)}
                helperText={touched.model && errors.model}
                variant="outlined"
                fullWidth
                placeholder="Enter vehicle Model"
              />
            </Grid>

            <Grid
              item
              lg={4}
              md={6}
              sm={12}
              xs={12}
              style={{ marginTop: "-5px" }}
            >
              <CustomFormLabel htmlFor="device_name">
                Device name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Select
                id="device_name"
                name="device_name"
                value={selectedDevice}
                onChange={(selectedOption) => {
                  setSelectedDevice(selectedOption);

                  handleChange({
                    target: {
                      name: "device_name",
                      value: selectedOption ? selectedOption.value : "",
                    },
                  });
                  fetch_imei_no(selectedOption ? selectedOption.value : "");
                }}
                onBlur={handleBlur}
                options={device_name.map((option) => ({
                  label: `${option.device_name} / ${option.imei_no}`,
                  value: option.device_name,
                }))}
                placeholder="Select Device"
                isSearchable
                fullWidth
                variant="outlined"
              />
            </Grid>

            <Grid item lg={4} md={12} sm={12} xs={12}>
              <CustomFormLabel htmlFor="installation_datetime">
                Allotment Date <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="installation_datetime"
                name="installation_datetime"
                type="date"
                value={installation_datetime_value.installation_datetime}
                // onChange={handleChange}
                onChange={(event, newValue) => {
                  handleChange(event);
                  handleTime(event);
                }}
                onBlur={handleBlur}
                error={
                  touched.installation_datetime &&
                  Boolean(errors.installation_datetime)
                }
                helperText={
                  touched.installation_datetime && errors.installation_datetime
                }
                variant="outlined"
                fullWidth
              />
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default DeviceInstallationForm;
